import { RouteRecordRaw } from 'vue-router';

const stockItemsRoutes : Array<RouteRecordRaw> = [
    {
        path: '/stock_items',
        name: 'stock_items',
        component: () => import( './views/StockItemsView.vue'),
        meta: {
            requiresAuth: true
        }
    },
    
]

export default stockItemsRoutes;